
if (import.meta.hot) {
  import.meta.hot.accept((mod) => {
    const router = import.meta.hot.data.router
    const generateRoutes = import.meta.hot.data.generateRoutes
    if (!router || !generateRoutes) {
      import.meta.hot.invalidate('[nuxt] Cannot replace routes because there is no active router. Reloading.')
      return
    }
    router.clearRoutes()
    const routes = generateRoutes(mod.default || mod)
    function addRoutes (routes) {
      for (const route of routes) {
        router.addRoute(route)
      }
      router.replace(router.currentRoute.value.fullPath)
    }
    if (routes && 'then' in routes) {
      routes.then(addRoutes)
    } else {
      addRoutes(routes)
    }
  })
}

export function handleHotUpdate(_router, _generateRoutes) {
  if (import.meta.hot) {
    import.meta.hot.data ||= {}
    import.meta.hot.data.router = _router
    import.meta.hot.data.generateRoutes = _generateRoutes
  }
}
import { default as _91_46_46_46slug_93bxqMJRabVdWZXuvF9FWZmMIujcSvRxUBxs5JzQp4EB0Meta } from "/opt/build/repo/pages/[...slug].vue?macro=true";
import { default as index6oVCcC58A1UoJMCIOJEC9RFqLWXra5E4afzeS5Zg1SgMeta } from "/opt/build/repo/pages/grants/index.vue?macro=true";
import { default as _91slug_93qRotakriZ2HAC5LNZC5Vq7nTsvUKKdBqVHUDVMxbWgEMeta } from "/opt/build/repo/pages/grants/[slug].vue?macro=true";
import { default as _91slug_932C0mu2q7n27KHrA9D1mKeA9F3MTtwkDYomuk_45JkTYvEMeta } from "/opt/build/repo/pages/videos/[slug].vue?macro=true";
import { default as index1l61P0qgOE2EcgrDL9KHAnohYl0xXwi8wmc0UmVUlskMeta } from "/opt/build/repo/pages/resources/index.vue?macro=true";
import { default as _91slug_93Efm_nmYpMC3NQXdPP264zwacgb2H9fWlkihCApSCsm8Meta } from "/opt/build/repo/pages/resources/[slug].vue?macro=true";
import { default as _91_46_46_46slug_93JClHQMDPF2O4j6nTOgHodh_S12CtH_eoyzFOJ_dx3GMMeta } from "/opt/build/repo/pages/digital-screen/[...slug].vue?macro=true";
import { default as indexAR4JsbFmHF9UX1_qlq0TfEGHR4nS0rRXCaqACk5TMsYMeta } from "/opt/build/repo/pages/password-protected/index.vue?macro=true";
import { default as indexlEFOedJ4zfUy5iuocYyRlzft8ZiK3pVIYTqZTbHYzZYMeta } from "/opt/build/repo/pages/digital-screen/mode/index.vue?macro=true";
import { default as indexV2f_451h8bl7G6KbDZA7mnWHAb7nSgWTRxdLWtarssybgMeta } from "/opt/build/repo/pages/entry-password-protected/index.vue?macro=true";
import { default as _91slug_93_45PwuY6YboWxmAO84J4BU3Uv80nW1cQ2tD0CL3rN_zTIMeta } from "/opt/build/repo/pages/digital-screen/pricing-item/[slug].vue?macro=true";
export default [
  {
    name: "slug",
    path: "/:slug(.*)*",
    meta: _91_46_46_46slug_93bxqMJRabVdWZXuvF9FWZmMIujcSvRxUBxs5JzQp4EB0Meta || {},
    component: () => import("/opt/build/repo/pages/[...slug].vue")
  },
  {
    name: "grants",
    path: "/grants",
    meta: index6oVCcC58A1UoJMCIOJEC9RFqLWXra5E4afzeS5Zg1SgMeta || {},
    component: () => import("/opt/build/repo/pages/grants/index.vue")
  },
  {
    name: "grants-slug",
    path: "/grants/:slug()",
    meta: _91slug_93qRotakriZ2HAC5LNZC5Vq7nTsvUKKdBqVHUDVMxbWgEMeta || {},
    component: () => import("/opt/build/repo/pages/grants/[slug].vue")
  },
  {
    name: "videos-slug",
    path: "/videos/:slug()",
    meta: _91slug_932C0mu2q7n27KHrA9D1mKeA9F3MTtwkDYomuk_45JkTYvEMeta || {},
    component: () => import("/opt/build/repo/pages/videos/[slug].vue")
  },
  {
    name: "resources",
    path: "/resources",
    component: () => import("/opt/build/repo/pages/resources/index.vue")
  },
  {
    name: "resources-slug",
    path: "/resources/:slug()",
    meta: _91slug_93Efm_nmYpMC3NQXdPP264zwacgb2H9fWlkihCApSCsm8Meta || {},
    component: () => import("/opt/build/repo/pages/resources/[slug].vue")
  },
  {
    name: "digital-screen-slug",
    path: "/digital-screen/:slug(.*)*",
    meta: _91_46_46_46slug_93JClHQMDPF2O4j6nTOgHodh_S12CtH_eoyzFOJ_dx3GMMeta || {},
    component: () => import("/opt/build/repo/pages/digital-screen/[...slug].vue")
  },
  {
    name: "password-protected",
    path: "/password-protected",
    meta: indexAR4JsbFmHF9UX1_qlq0TfEGHR4nS0rRXCaqACk5TMsYMeta || {},
    component: () => import("/opt/build/repo/pages/password-protected/index.vue")
  },
  {
    name: "digital-screen-mode",
    path: "/digital-screen/mode",
    meta: indexlEFOedJ4zfUy5iuocYyRlzft8ZiK3pVIYTqZTbHYzZYMeta || {},
    component: () => import("/opt/build/repo/pages/digital-screen/mode/index.vue")
  },
  {
    name: "entry-password-protected",
    path: "/entry-password-protected",
    component: () => import("/opt/build/repo/pages/entry-password-protected/index.vue")
  },
  {
    name: "digital-screen-pricing-item-slug",
    path: "/digital-screen/pricing-item/:slug()",
    meta: _91slug_93_45PwuY6YboWxmAO84J4BU3Uv80nW1cQ2tD0CL3rN_zTIMeta || {},
    component: () => import("/opt/build/repo/pages/digital-screen/pricing-item/[slug].vue")
  }
]